import AdminApi from '../../services/api'
import InvoicesApi from '../../services/apiInvoices'
import swal from 'sweetalert2';
import session from "../../services/session";
import { uuid } from 'vue-uuid';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {compile} from "vue-template-compiler";
import templateEfaktura from '!raw-loader!../../assets/files/template_efaktura.xml';
import templateEfakturaPdv from '!raw-loader!../../assets/files/template_efaktura_pdv.xml';
const InvoiceApiService = new InvoicesApi()
const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            company: null,
            cancelFlag: false,
            companyId: '',
            filter: '',
            companyName: '',
            fromDate: '',
            toDate: '',
            total: 0,
            amount: 0,
            openAddOrder: false,
            showOrders: false,
            isAdmin: false,
            histories: [],
            invoicesGroup: [],
            types: [],
            tabIndex: 0,
            config: {
                greenVoucher: 0,
                blueVoucher: 0,
                whiteVoucher: 0,
            },
        }
    },
    computed: {
        filteredUsers() {
            this.amount = 0;
            return this.histories.filter(item => {
                var isIn = this.checkNull(item.company.name).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                if(isIn){ this.amount = this.amount + item.greenVouchers;}
                return isIn;
            })
        }
    },
    methods: {
        getHistory: getHistory,
        getAddress: getAddress,
        addCupons: addCupons,
        downloadSpecification: downloadSpecification,
        generateEfaktura: generateEfaktura,
        sendFileToEfaktura: sendFileToEfaktura,
        getInvoiceJSONById: getInvoiceJSONById,
        sendMail: sendMail,
        sendMailSpecification: sendMailSpecification,
        getModuleStyle: getModuleStyle,
        generatePdf: generatePdf,
        getStatusEfaktra: getStatusEfaktra,
        visibleDevelop: visibleDevelop,
        sendInvoice: sendInvoice,
        onlyDownload: onlyDownload,
        setTab: setTab,
        formatDate: formatDate,
        format2Date: format2Date,
        keymonitor: keymonitor,
        deleteVoucher: deleteVoucher,
        clickSearch: clickSearch,
        onClickUser: onClickUser,
        fetchStatuses: fetchStatuses,
        openAddUserModal: openAddUserModal,
        formatCode: formatCode,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        loadConfig: loadConfig,
        invoiceNumber: invoiceNumber,
        getType: getType,
        updateInvoiceToken: updateInvoiceToken,
        deleteCompanyStuff: deleteCompanyStuff,
        resetCompanyCupons: resetCompanyCupons,
        checkNull: checkNull,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

        base64ToUtf8(b64) {
            b64 = (b64 || '')
                .replace(/ /g, '+')      // za svaki slučaj
                .replace(/-/g, '+')
                .replace(/_/g, '/');
            while (b64.length % 4) b64 += '=';

            const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
            return new TextDecoder('utf-8').decode(bytes);
        }

    },
    beforeDestroy() {
        this.cancelFlag = true;
    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.cancelFlag = false;
        this.updateInvoiceToken()
        this.isAdmin = session.getRole() === 'ADMIN'
        this.companyName = this.$route.query.name != null ? this.$route.query.name : "";
        this.companyId = this.$route.query.id;
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.loadConfig();
        if(this.$route.query.company != null){
            this.company = JSON.parse(this.base64ToUtf8(this.$route.query.company));
            //izmenjeno citanje ovo iznad
            // this.company = JSON.parse(decodeURIComponent(escape(atob(this.$route.query.company))))
        }else{
            this.companyName = "Sve"
        }
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
        'filteredUsers': function (newVal) {
            console.log("histories changed")
        }
    }
}

function updateInvoiceToken() {
    if(session.isInvoiceTokenExpire()){
        InvoiceApiService.signIn()
            .then((response) => {
                session.setInvoiceData(response.data)
            })
            .catch((error) => {

            })
    }
}

function loadConfig() {
    let _self = this;
    AdminApiService.getConfiguration()
        .then((response) => {
            _self.config.greenVoucher = response.data.vouchers.green;
            _self.config.blueVoucher = response.data.vouchers.blue;
            _self.config.whiteVoucher = response.data.vouchers.white;
        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getHistory() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    // swal('Molimo sačekajte', 'Kreiranje izveštaja', 'warning');
    _self.isDateError = null;
    _self.cancelFlag = true;
    var hasOrder = _self.showOrders;//_self.tabIndex === 1;
    var companyParam = this.companyId != null ? "&companyId="+_self.companyId : "";
    var param =  "?fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo + companyParam +"&hasOrder="+hasOrder;
    AdminApiService.getVoucherHistory(param)
        .then((response) => {
            swal.close();
            if(_self.showOrders){
                _self.histories = response.data.filter(e => e.greenVouchers !== 0 && e.greenVouchers < -50);
                var total = 0
                _self.histories.forEach(e => {
                    total = total + e.greenVouchers
                })
                _self.total = total


            }else{
                _self.histories = response.data;
            }
            _self.histories.forEach(e => {
                if(e.invoice != null && e.invoice.SalesInvoiceId != null){
                    e.invoice.status = "LOADING"
                }else{
                    if(e.invoice.error == null){
                        e.invoice = null
                    }
                }
            })

            let historyWithSales = _self.histories.filter(i => i.invoice != null && i.invoice.error == null)

            _self.invoicesGroup = []
            var tempList = [];
            for(var i = 0; i < historyWithSales.length; i++){
                var k = i + 1;
                tempList.push(historyWithSales[i].invoice.SalesInvoiceId)
                if(k % 3 === 0){
                    _self.invoicesGroup.push(tempList)
                    tempList = [];
                }
            }
            if(tempList.length > 0){
                _self.invoicesGroup.push(tempList)
            }


            _self.cancelFlag = false;
            _self.fetchStatuses()

        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getHistory();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}


function deleteCompanyStuff(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete menadžera " + item.username + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteCompanyStuff(item.id, _self.companyId)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali menadžera', 'success')
                _self.getHistory();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function changedDateFrom() {

}


function changedDateTo() {

}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY - HH:mm')
}

function format2Date(date) {
    return this.$moment(new Date(date )).format('HHmmssSSS')
}


function getModuleStyle(index) {
    if(index === this.tabIndex){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: #1b1e24; color: white;"
    }
}

function setTab(tab) {
    this.tabIndex = tab;
    this.getHistory()
}

function resetCompanyCupons(){
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite postavite sve kupone od kompanije na 0 ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.resetCompanyVoucher(_self.companyId)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste resetovali stanje kompanije.', 'success')
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function deleteVoucher(voucherId){
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrišete akciju?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteVoucherById(_self.companyId, voucherId)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali akciju.', 'success')
                _self.getHistory();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function sendInvoice(item){
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da pošaljete fakturu?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.generatePdf(item, false)
    });
}

function onlyDownload(item){
    this.generatePdf(item, true)
}

function generatePdf(item, downloadOnly){
    var greenCount = item.greenVouchers;
    var blueCount = item.blueVouchers;
    var whiteCount = item.whiteVouchers;
    var amount = this.config.greenVoucher * greenCount + this.config.whiteVoucher * whiteCount + this.config.blueVoucher * blueCount;
    var currentDay = this.$moment(Date.now()).format('DD.MM.YYYY.')

    var mainBody = [
        [{text: 'Vrsta robe odn. usluga', style: 'miniHeaderTable2'}, {text: 'Količina', style: 'miniHeaderTable2'}, {text: 'Cena', style: 'miniHeaderTable2'}, {text: 'Vrednost RSD', style: 'miniHeaderTable2'}],
        ['',{text: 'Ukupno:', style: 'mainHeaderTable'},'',{text: ''+amount.toFixed(2), style: 'mainRowTable'}],
        ['',{text: 'Ukupno RSD:', style: 'mainHeaderTable'},'',{text: ''+amount.toFixed(2), style: 'mainRowTable'}],
        ['',{text: 'Za plaćanje RSD:', style: 'mainHeaderTable'},'',{text: ''+amount.toFixed(2), style: 'mainRowTable'}]
    ];
    if(blueCount > 0){
        mainBody.splice(1, 0,  [{text: '(003) Kuponi u trećoj zoni', style: 'mainRowTable'},{text: blueCount.toFixed(2) + ' kom', style: 'mainRowTable'},{text: ''+ this.config.blueVoucher.toFixed(2), style: 'mainRowTable'},{text: ''+ (this.config.blueVoucher * blueCount).toFixed(2), style: 'mainRowTable'}]);
    }
    if(whiteCount > 0){
        mainBody.splice(1, 0,  [{text: '(002) Kuponi u drugoj zoni', style: 'mainRowTable'},{text: whiteCount.toFixed(2) + ' kom', style: 'mainRowTable'},{text: ''+ this.config.whiteVoucher.toFixed(2), style: 'mainRowTable'},{text: ''+ (this.config.whiteVoucher * whiteCount).toFixed(2), style: 'mainRowTable'}]);
    }
    if(greenCount > 0){
        mainBody.splice(1, 0,  [{text: 'Usluge kurirske dostave' , style: 'mainRowTable'},{text: (greenCount / 500).toFixed(2) + ' kom', style: 'mainRowTable'},{text: ''+ (this.config.greenVoucher * 500).toFixed(2), style: 'mainRowTable'},{text: ''+ (this.config.greenVoucher * greenCount).toFixed(2), style: 'mainRowTable'}]);
    }

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        content: [
            {text: '321 DOSTAVA', style: 'header'},
            'SLOBODAN RISTIC PR',
            'VESELINA MASLEŠE 2',
            '21000 Novi Sad',
            'MB: 66164934',
            'PIB: 112528872',
            {
                style: 'tableExample',
                table: {

                    headerRows: 1,
                    // dontBreakRows: true,
                    // keepWithHeaderRows: 1,
                    widths: ['*',  '*'],
                    body: [
                        [{text: '', style: 'tableHeader'}, {text: '', style: 'tableHeader'},],
                        [{text: 'Račun', style: 'headerRacun'}, {text: item.company.info.name + '\n' + item.company.info.address +'\n'+ item.company.info.zip + ' ' + item.company.info.city + '\n' + 'MB: ' + item.company.info.mb +'\nPIB: ' + item.company.info.pib , style:'companyInfo'} ],
                        [{
                            style: 'miniTableExample',
                            table: {
                                headerRows: 1,
                                // dontBreakRows: true,
                                // keepWithHeaderRows: 1,
                                body: [
                                    [{text: 'Broj:', style: 'miniHeaderTable'}, {text: ''+ this.invoiceNumber(item), style: 'miniHeaderTable'},],
                                    [{text: 'Mesto:', style: 'miniRowTable'}, {text: 'Novi Sad', style: 'miniRowTable'},],
                                    [{text: 'Poziv na broj:', style: 'miniRowTable'}, {text: ''+ this.invoiceNumber(item), style: 'miniRowTable'},],
                                    [{text: 'Datum računa:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    [{text: 'Datum prometa:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    [{text: 'Datum valute:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    // [{text: 'Osnova za račun:', style: 'miniRowTable'}, {text: 'Lovćenska', style: 'miniRowTable'},],
                                ]
                            },
                            layout: 'noBorders'
                        }, {text: '', style:'companyInfo'} ],
                    ]
                },
                layout: 'noBorders'
            },
            {
                style: 'miniTableExample',
                table: {
                    headerRows: 1,
                    widths: ['*',  'auto', 'auto', 'auto'],
                    body: mainBody
                },
                layout: 'lightHorizontalLines'
            },
            {
                text: [
                    '\n',
                    '\n',
                    {text: 'Uplatu izvršiti na tekući račun broj: ', fontSize: 10, bold: false},
                    {text: '325-9500700187549-51', fontSize: 10, bold: true},
                    '\n',
                    '\n',
                    {text: 'Napomena: ', fontSize: 10, bold: true},
                    {text: 'Preduzetnik nije u sistemu PDV. PDV nije obračunat u skladu sa Članom 33 Zakona o PDV.', fontSize: 10, bold: false},
                    '\n',
                    '\n',
                    {text: 'Račun je izdat u elektronskom obliku, nema obaveze štampanja i važeći je bez pečata i potpisa.', fontSize: 10, bold: false},
                    '\n',
                    '\n',
                    {text: 'Izdao račun:', fontSize: 10, bold: true},
                    '\n',
                    {text: 'Slobodan Ristić', fontSize: 10, bold: false},

                ]
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 10,
                margin: [0, 0, 0, 0]
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0]
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 5, 0, 15]
            },
            miniTableExample: {
                margin: [0, 2, 0, 2]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fileName = ''+this.invoiceNumber(item);
    if(downloadOnly){
        pdfMake.createPdf(dd).download(''+this.invoiceNumber(item))
    }else{
        let _self = this;
        const pdfDocGenerator = pdfMake.createPdf(dd);

        pdfDocGenerator.getBase64((data) => {
            _self.sendMail(item, data, fileName, dd)
        });
    }
}

function sendMail(item, attachment, filename, dd){
    if(item.company.info.email == null || item.company.info.email.length === 0){
        swal('Greška', "Email nije podešen za kompaniju", 'error')
        return
    }
    var currentDay = this.$moment(Date.now()).format('DD.MM.YYYY.')
    let newModel = {
        to: item.company.info.email,
        subject: "321 Dostava, Faktura za: " + currentDay,
        text: "<html><body>Poštovani,<br><br>u prilogu se nalazi faktura.<br><br> Pozdrav,<br>Slobodan Ristić</body></html>",
        attachment: {
            content: attachment,
            filename: filename,
            type: "application/pdf"
        },
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Slanje mail-a, molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });

    AdminApiService.sendMail(newModel, )
        .then((response) => {
            swal('Uspeš', "Mail uspešno poslat", 'success')
            pdfMake.createPdf(dd).download(filename)
        })
        .catch((error) => {
            swal('Greška', "Mail nije poslat", 'error')
        })
}

function sendMailSpecification(item, attachment, filename, dd, dateFrom, dateTo){
    if(item.info.email == null || item.info.email.length === 0){
        swal('Greška', "Email nije podešen za kompaniju", 'error')
        return
    }
    let newModel = {
        to: item.info.email,
        subject: "321 Dostava, Specifikacija",
        text: "<html><body>Poštovani,<br><br>u prilogu se specifikacija za period: "+ dateFrom + " - " + dateTo +" .<br><br> Pozdrav,<br>Slobodan Ristić</body></html>",
        attachment: {
            content: attachment,
            filename: filename,
            type: "application/pdf"
        },
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Slanje mail-a, molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });

    AdminApiService.sendMail(newModel, )
        .then((response) => {
            swal('Uspeš', "Mail uspešno poslat", 'success')
            pdfMake.createPdf(dd).download(filename)
        })
        .catch((error) => {
            swal('Greška', "Mail nije poslat", 'error')
        })
}

function formatCode(item){
    return '#' +item.id.substr(0,6) + this.format2Date(item.timestamp);
}

function invoiceNumber(item){
    return '' +item.id.substr(0,6) + this.format2Date(item.timestamp);
}

function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}

function getAddress(item){
    if(item.order == null) return ""
    if(item.order.address == null) return ""
    return item.order.address.street + ", " + item.order.address.city
}

function generateEfaktura(item){
    var isPdvEnabled = true
    let dataFormat = "YYYY-MM-DD"
    var cModel = {
        id: this.invoiceNumber(item),
        danasnjiDatum: this.$moment(Date.now()).format(dataFormat),
        datumDospeca: this.$moment(Date.now()).format(dataFormat),
        note: isPdvEnabled ? "" : "Preduzetnik nije u sistemu PDV. PDV nije obračunat u skladu sa Članom 33 Zakona o PDV.",
        noteDole: "Uplatu izvršiti na tekući račun broj: 325-9500700187549-51 \n Račun je izdat u elektronskom obliku, nema obaveze štampanja i važeći je bez pečata i potpisa.\nIzdao račun: Slobodan Ristić",
        pib: "112528872",
        name: "321 DOSTAVA",
        address: "VESELINA MASLEŠE 2",
        city: "Novi Sad",
        postalCode: "21000",
        mb: "66164934",
    }
    var dataModel = {
        amount: this.config.greenVoucher * item.greenVouchers,
        count: (item.greenVouchers / 500),
        itemPriceTotal: (this.config.greenVoucher * 500),
        itemName: "Usluge kurirske dostave",
        itemDesc: "Usluge kurirske dostave",
        itemPrice: (this.config.greenVoucher * 500)
    }

    var efaktura = isPdvEnabled ? templateEfakturaPdv : templateEfaktura
    efaktura = efaktura.replaceAll("QWE_ID", cModel.id )
    efaktura = efaktura.replace("QWE_DATUM_DANASNJI", cModel.danasnjiDatum)
    efaktura = efaktura.replace("QWE_DATUM_DOSPECA", cModel.datumDospeca)
    efaktura = efaktura.replace("QWE_NOTE_DOLE", cModel.noteDole)
    efaktura = efaktura.replace("QWE_NOTE", isPdvEnabled ? cModel.noteDole : cModel.note)
    efaktura = efaktura.replaceAll("QWE_MY_PIB", cModel.pib)
    efaktura = efaktura.replaceAll("QWE_MY_IME", cModel.name)
    efaktura = efaktura.replaceAll("QWE_MY_ADDRESS", cModel.address)
    efaktura = efaktura.replaceAll("QWE_MY_CITY", cModel.city)
    efaktura = efaktura.replaceAll("QWE_MY_POSTAL_CODE", cModel.postalCode)
    efaktura = efaktura.replaceAll("QWE_MY_MATICNI_BROJ", cModel.mb)
    efaktura = efaktura.replaceAll("QWE_RACUN_PRODAVCA", "325950070018754951")
    efaktura = efaktura.replaceAll("QWE_START_DATE", this.$moment(Date.now()).format(dataFormat))
    efaktura = efaktura.replaceAll("QWE_END_DATE", this.$moment(Date.now()).format(dataFormat))
    //Kupac
    efaktura = efaktura.replaceAll("QWE_KUPAC_PIB", item.company.info.pib)
    efaktura = efaktura.replaceAll("QWE_KUPAC_IME", item.company.info.name.replace("&", "&amp;"))
    efaktura = efaktura.replaceAll("QWE_KUPAC_ADRESA", item.company.info.address)
    efaktura = efaktura.replaceAll("QWE_KUPAC_CITY", item.company.info.city)
    efaktura = efaktura.replaceAll("QWE_KUPAC_POSTAL_CODE", item.company.info.zip)
    efaktura = efaktura.replaceAll("QWE_KUPAC_MATICNI_BR", item.company.info.mb)
    efaktura = efaktura.replaceAll("QWE_MAIL_KUPAC", item.company.info.email)
    efaktura = efaktura.replaceAll("QWE_DATUM_PROMETA", this.$moment(Date.now()).format(dataFormat))

    var pdv = (dataModel.amount * 0.2).toFixed(2)
    var pdvItem = (500 * 0.2).toFixed(2)
    //faktura
    efaktura = efaktura.replaceAll("QWE_TOTAL_WITH_TAX", (dataModel.amount + dataModel.amount * 0.2).toFixed(2))
    efaktura = efaktura.replaceAll("QWE_TOTAL", dataModel.amount.toFixed(2))
    efaktura = efaktura.replaceAll("QWE_BR_KOMADA", dataModel.count)
    efaktura = efaktura.replaceAll("QWE_UKUPNA_CENA_STAVKE", dataModel.itemPriceTotal.toFixed(2))
    efaktura = efaktura.replaceAll("QWE_OPIS_STAVKE", dataModel.itemDesc)
    efaktura = efaktura.replaceAll("QWE_IME_STAVKE", dataModel.itemName)
    efaktura = efaktura.replaceAll("QWE_CENA_STAVKE", dataModel.itemPrice.toFixed(2))
    //PDV

    efaktura = efaktura.replaceAll("QWE_TAX_AMOUNT_ITEM", pdvItem)
    efaktura = efaktura.replaceAll("QWE_TAX_AMOUNT", pdv)


    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Slanje fakture...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    this.sendFileToEfaktura(item, this.invoiceNumber(item), efaktura).then(r => {

    })
}

function sendFileToEfaktura(item, name, xmlString){
    let _self = this;
    return new Promise((resolve, reject) => {
        var sendToCir = 'No';
        xmlString = xmlString
            .replaceAll("&","&#38;")
            .replaceAll("ć", "&#263;")
            .replaceAll("Ć","&#262;")
            .replaceAll("đ","&#273;")
            .replaceAll("Đ","&#272;")
            .replaceAll("č","&#269;")
            .replaceAll("Č","&#268;")
            .replaceAll("š","&#353;")
            .replaceAll("Š","&#352;")
            .replaceAll("ž","&#382;")
            .replaceAll("Ž","&#381;")

        InvoiceApiService.sendInvoice(xmlString, uuid.v1(), name, Date.now(), sendToCir)
            .then((response) => {
                swal('Uspešno','Faktura uspešno poslata na portal', 'success')
                _self.addCupons({
                    status: 'Sent',
                    InvoiceId: '' + response.data.InvoiceId,
                    PurchaseInvoiceId: '' + response.data.PurchaseInvoiceId,
                    SalesInvoiceId: '' + response.data.SalesInvoiceId,
                }, item)
                resolve()
            })
            .catch(error => {
                // var item = _self.rawFiles[i];
                try {
                    let errorDesc =  error.data.ErrorCode == null ? error.data.localized_error_message : error.data.ErrorCode
                    swal('Greška', errorDesc, 'error');
                    _self.addCupons({error: errorDesc}, item)
                }catch (e){
                    swal('Greška', 'Nepoznata greška', 'error');
                    _self.addCupons({error: 'Nepoznata greška'}, item)
                }
                resolve();
            })
    });
}

function addCupons(invoiceObject, item){
    let _self = this;
    const newModel = {
        invoice: invoiceObject
    };
    AdminApiService.addEfakturaToVoucherCompany(item.company.id, item.id, newModel)
        .then((response) => {
            let found = _self.histories.filter(e => e.id === item.id)
            _self.histories.forEach(e => {
                if(e.id === item.id){
                    if(invoiceObject.error == null){
                        e.invoice = {
                            InvoiceId: '' + invoiceObject.InvoiceId,
                            PurchaseInvoiceId: '' + invoiceObject.PurchaseInvoiceId,
                            SalesInvoiceId: '' + invoiceObject.SalesInvoiceId,
                            status: invoiceObject.status
                        }
                    }else{
                        e.invoice = {
                            error: invoiceObject.error
                        }
                    }
                }
            })
            _self.filter = ' '
            _self.filter = ''
        })
        .catch((error) => {
            swal('Greška', error.message, 'error');
        })
}

function getStatusEfaktra(item){
    if(item.invoice.status == null) return 'Ucitavanje...'
    switch (item.invoice.status){
        case 'Sent':
            return 'Poslato';
        case 'Approved':
            return 'Odobreno';
        case 'Rejected':
            return 'Odbijeno';
        case 'Cancelled':
            return 'Stornirano';
        case 'Sent fail':
            return 'Neuspešno slanje';
        case 'LOADING':
            return ''
        default:
            return item.invoice.status;
    }
}

function fetchStatuses(){
    this.cancelFlag = false;
    let _self = this
    var i = 0;
    const delay = (delayInms) => {
        return new Promise(resolve => setTimeout(resolve, delayInms));
    }

    const delaySend = async () => {
        for(i = 0; i < _self.invoicesGroup.length; i++){
            if(this.cancelFlag) return;
            await delay(1100)
            var item = _self.invoicesGroup[i];
            if(this.cancelFlag) return;
            if(item.length > 0){
                await _self.getInvoiceJSONById(item[0]);
            }
            if(this.cancelFlag) return;
            if(item.length > 1){
                await _self.getInvoiceJSONById(item[1]);
            }
            if(this.cancelFlag) return;
            if(item.length > 2){
                await _self.getInvoiceJSONById(item[2]);
            }
            if(this.cancelFlag) return;
        }

        // swal.close();
    }

    delaySend();
}

function getInvoiceJSONById(id){
    let _self = this;
    return new Promise((resolve, reject) => {
        InvoiceApiService.getSalesInvoiceJSON(id)
            .then((response) => {
                var invoiceToSearch = "" + id + ""
                let foundInvoice = _self.histories.filter(i => i.invoice != null && i.invoice.SalesInvoiceId != null && i.invoice.SalesInvoiceId === invoiceToSearch)
                if(foundInvoice.length > 0){
                    let iId = foundInvoice[0].invoice.InvoiceId
                    let pId = foundInvoice[0].invoice.PurchaseInvoiceId
                    let sId = foundInvoice[0].invoice.SalesInvoiceId
                    foundInvoice[0].invoice = {
                        status: response.data.Status,
                        InvoiceId: '' + iId,
                        PurchaseInvoiceId: '' + pId,
                        SalesInvoiceId: '' + sId,
                    }
                    foundInvoice[0].invoice.status = response.data.Status;
                }
                resolve();
            })
            .catch(error => {
                var invoiceToSearch = "" + id + ""
                let foundInvoice = _self.histories.filter(i => i.invoice != null && i.invoice.SalesInvoiceId != null && i.invoice.SalesInvoiceId === invoiceToSearch)
                if(foundInvoice.length > 0){
                    let iId = foundInvoice[0].invoice.InvoiceId
                    let pId = foundInvoice[0].invoice.PurchaseInvoiceId
                    let sId = foundInvoice[0].invoice.SalesInvoiceId
                    foundInvoice[0].invoice = {
                        statusError: 'Greška - status',
                        status: 'Greška - status',
                        InvoiceId: '' + iId,
                        PurchaseInvoiceId: '' + pId,
                        SalesInvoiceId: '' + sId,
                    }
                }
                resolve();
            })
    });
}

function getType(item){
    if(item.invoice == null) return "Xfalse"
    var s = ""
    s = s + " 1. " + item.invoice != null
    s = s + " 2. " + item.invoice != null ? item.invoice.error != null : null
    s = s + " 3. " + item.invoice != null ? item.invoice.statusError != null : null
    s = s + " 4. " + item.invoice != null ? item.invoice.statusError != null : null
    return s
}

function checkNull(value){
    if(value == null) return '';
    return value;
}

function downloadSpecification(sendMail){
    var mapCount = new Map();

    var widthRow = ['auto', 'auto', 'auto', 'auto', 'auto']
    var mainBody = [];
    mainBody.push(['R.br', 'Kod', 'Datum', 'Kredita', 'Adresa dostave'])
    var i = 1;
    this.filteredUsers.forEach(u => {
        var row = [];
        var city = u != null && u.order.address != null ? u.order.address.street : ''
        var street = u != null && u.order.address != null ? ', ' + u.order.address.city : ''
        row.push(i);
        row.push("#" + u.id.substr(0, 6) + this.format2Date(u.timestamp));
        row.push(this.formatDate(u.timestamp))
        row.push(u.greenVouchers)
        row.push(city + street)
        mainBody.push(row)
        i++;

        if(mapCount.has(u.greenVouchers)){
            mapCount.set(u.greenVouchers, mapCount.get(u.greenVouchers) + 1);
        }else{
            mapCount.set(u.greenVouchers, 1);
        }
    })

    var firstTableWidth = ['auto', 'auto', 'auto']
    var mainBodyFirstTable = [];
    mainBodyFirstTable.push(['Vrednost kredita', 'Broj dostava za kredit', 'Potrošeno kredita'])
    for (let [key, value] of mapCount) {
        mainBodyFirstTable.push([key, value, key * value])
    }

    var dateFrom = this.$moment(new Date(this.fromDate )).format('DD-MM-YYYY')
    var dateTo = this.$moment(new Date(this.toDate )).format('DD-MM-YYYY')

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        content: [
            {text: this.companyName, style: 'header'},
            {text: 'Izveštaj za period od '+dateFrom + ' do '+ dateTo , style: 'header2'},
            {text: 'Ukupan broj dostava: ' + this.filteredUsers.length , style: 'header3'},
            {text: 'Broj dostava grupisan po ceni', style: 'mainHeaderTable'},
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: firstTableWidth,
                    body: mainBodyFirstTable
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        if(rowIndex === 0) return '#AAAAAA';
                        return (columnIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
                // layout: 'lightHorizontalLines'
            },
            {text: 'Ukupno potrošenih kredita: ' + this.total , style: 'header3'},
            {text: 'Lista svih dostava', style: 'mainHeaderTable'},
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: widthRow,
                    body: mainBody
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        if(rowIndex === 0) return '#AAAAAA';
                        return (columnIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
                // layout: 'lightHorizontalLines'
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header2: {
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header3: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 7,
                margin: [0, 0, 0, 0],
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0]
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 5, 0, 15]
            },
            miniTableExample: {
                margin: [0, 2, 0, 2]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fileName = 'specifikacija-'+this.companyName.replaceAll(" ","_")+'.pdf';
    if(sendMail){
        let _self = this;
        const pdfDocGenerator = pdfMake.createPdf(dd);
        pdfDocGenerator.getBase64((data) => {
            _self.sendMailSpecification(this.company, data, fileName, dd, dateFrom, dateTo)
        });
    }else{
        pdfMake.createPdf(dd).download(fileName)
    }

}


// WEBPACK FOOTER //
// ./src/components/Company/VoucherHistory.js